// Generated by ReScript, PLEASE EDIT WITH CARE


function toString(val) {
  if (val) {
    return "New Flow";
  } else {
    return "Old Flow";
  }
}

export {
  toString ,
  
}
/* No side effect */
